import React from 'react';
import { Paper, Typography, Box, Stack, Chip, Divider } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';

const CandidateLanguages = ({ languages }) => {
    if (!languages || languages.length === 0) {
        return null;
    }

    const getProficiencyColor = (proficiency) => {
        if (!proficiency) return 'default';
        const level = proficiency.toLowerCase();
        if (level.includes('native') || level.includes('fluent')) return 'success';
        if (level.includes('advanced') || level.includes('professional')) return 'primary';
        if (level.includes('intermediate')) return 'warning';
        return 'default';
    };

    return (
        <Paper 
            elevation={0}
            sx={{ 
                p: 3, 
                mb: 3,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <LanguageIcon sx={{ color: 'text.primary' }} />
                <Typography variant="h6" fontWeight={600} color="text.primary">
                    Languages
                </Typography>
            </Box>
            <Divider sx={{ mb: 2 }} />
            <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ gap: 1 }}>
                {languages.map((lang) => (
                    <Chip
                        key={lang.id}
                        label={lang.proficiency ? `${lang.title} - ${lang.proficiency}` : lang.title}
                        color={getProficiencyColor(lang.proficiency)}
                        variant="outlined"
                        size="medium"
                    />
                ))}
            </Stack>
        </Paper>
    );
};

export default CandidateLanguages;
